<template>
    <div class="c-conversation__wrapper"
        :data-component-name="$options.name"
    >
        <!-- <pre> -->
            <!-- {{parentNotification}} -->
            <!-- {{conversationGroups}} -->
            <!-- {{ notification }} -->
        <!-- </pre> -->
        <div class="c-conversation-header" v-if="parentNotification">

            <div class="close-panel-button">
                <q-icon name="arrow_back_ios" @click="closePanel()" />
            </div>

            <div class="row flex-center full-width"
                onclick="document.querySelector('.js-moreinfo-wrapper').classList.add('is-active')"
            >
                <div class="-avatar" v-if="parentNotification.assignment">
                    <UserAvatar 
                        :name="parentNotification.assignment.assignedTo.name"
                        :email="parentNotification.assignment.assignedTo.email"
                    />
                </div>
                <div class="-avatar" v-else>
                    <UserAvatar 
                        :name="parentNotification.created_by.name"
                        :email="parentNotification.created_by.email"
                    />
                </div>
                <div class="flex-grow">
                    <!-- {{parentNotification.id}} -->
                    <h3 class="c-messages-header" v-if="parentNotification.project">
                        <div class="-assignedTo q-ml-sm">
                            {{ parentNotification.assignment.assignedTo.name }}
                            <UserProfileInfo defaultTab="schedule" v-if="notificationDetails && notificationDetails.assignments_details" size="12px" :scheduleScrollTo="notificationDetails.assignments_details.start_date" :currentDate="notificationDetails.assignments_details.start_date" :userProfile="parentNotification.assignment.assignedTo" class="q-ml-xs" />
                        </div>
                        <div class="q-ml-sm -project">
                            {{ parentNotification.project.name }}
                            <ProjectCardToggle class="-userprofile-info__toggle q-ml-sm" :myAssignments="true" :projectID="parentNotification.project.id" :size="'12px'" />
                        </div>
                    </h3>
                </div>
                <div class="-actions">
                    <div class="-updated_at" v-html="getRelativeDate(parentNotification.updated_at)"></div>
                
                    <div class="-delete q-ml-sm" @click.stop>
                        <q-icon name="delete" size="16px" @click="$emit('delete-notification', parentNotification)" />
                        <!-- <q-icon name="delete" size="16px" @click="deleteNotification(parentNotification)" /> -->
                    </div>
                </div>

                <!-- <div class="q-ml-auto q-mr-xs" v-if="myProfile && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER')">
                    <a href="" class="q-link -project" v-if="parentNotification.project" title="Aller au projet"
                        @click.prevent="$eventBus.$emit('jump-to-project', {projectID: parentNotification.project.id, currentDate: parentNotification.project.start_date})"
                    >
                        <q-icon name="launch" size="16px"/>
                    </a>
                </div> -->
            </div>

        </div>
        <!-- <pre>{{conversationGroups}}</pre> -->
        <div class="c-conversation-body" v-if="notification"
            @click="markAsRead(500)"
            @scroll="markAsRead(500)"
        >
            <div class="-conversations-group"
                :key="cgi"
                v-for="(conversations, cgi) in conversationGroups"
            >

                <div class="-signature" :class="{ '-from-me': conversations.created_by.id == myUserProfileID}"
                    v-if="conversations.created_by && conversations.infos.length">
                    <UserAvatar :name="conversations.created_by.name" :email="conversations.created_by.email" size="xs" />
                    <span class="">
                        {{ conversations.created_by.name }}
                    </span>
                </div>

                <div
                    v-if="conversations.infos.length"
                    class="-infos-wrapper"
                >
                    <div class="-date-time" v-html="date2str(conversations.infos[0].created_at).longWd" v-if="conversations.infos[0].created_at">
                    </div>
                    <q-expansion-item v-if="conversations.infos.length>3">
                        <template v-slot:header>
                            <q-item-section v-html="getInfosSummary(conversations.infos)">
                            </q-item-section>
                        </template>
                        <q-card class="bg-transparent">
                            <q-card-section>
                                <div v-for="(info, ii) in conversations.infos" :key="ii" class="-info-item">
                                    <span class="-info-date">
                                        <UserProfileInfo defaultTab="schedule" :scheduleScrollTo="info.infoAssignment.date"
                                            :currentDate="info.infoAssignment.date" :userProfile="info.infoAssignment.assignedTo" class="q-ml-xs" />
                                        {{ date2str(info.infoAssignment.date).long }}
                                    </span>
                                    <span class="-assignment">
                                        <span class="-label">Aff : </span>
                                        {{ info.infoAssignment.profession.name }}
                                    </span>
                                    <span :class="'-acceptation -' + getAcceptation(info.info).slug">
                                        <span class="-label">État : </span>
                                        {{ getAcceptation(info.info).text }}
                                    </span>
                                    <span class="-assignment">
                                        <span class="-label">Par : </span>
                                        {{ info.created_by.name }}
                                    </span>
                                    <span v-if="info.message && info.message.trim()!=''">
                                        <span class="-label">Raison : </span>
                                        {{ info.message }}
                                    </span>
                                </div>
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>

                    <div
                        v-for="(info, ii) in conversations.infos"
                        :key="ii"
                        class="-info-item"
                        v-else
                    >
                            <span class="-info-date">
                                <UserProfileInfo defaultTab="schedule" :scheduleScrollTo="info.infoAssignment.date"
                                    :currentDate="info.infoAssignment.date" :userProfile="info.infoAssignment.assignedTo" class="q-ml-xs" />
                                {{ date2str(info.infoAssignment.date).long }}
                            </span>
                            <span class="-assignment">
                                <span class="-label">Aff : </span>
                                {{ info.infoAssignment.profession.name }}
                            </span>
                            <span :class="'-acceptation -' + getAcceptation(info.info).slug">
                                <span class="-label">État : </span>
                                {{ getAcceptation(info.info).text }}
                            </span>
                            <span class="-assignment">
                                <span class="-label">Par : </span>
                                {{ info.created_by.name }}
                            </span>
                            <span v-if="info.message && info.message.trim()!=''">
                                <span class="-label">Raison : </span>
                                {{ info.message }}
                            </span>
                    </div>
                </div>
                <div class="-date-time"
                    v-html="conversations.created_at"
                    v-else-if="conversations.created_at"
                >
                </div>
                
                <div class="c-chat-user-group" v-if="conversations.created_by">
                    <div class="-signature"
                        :class="{ '-from-me': conversations.created_by.id == myUserProfileID}"
                        v-if="conversations.created_by && !conversations.infos.length"
                    >
                        <UserAvatar 
                            :name="conversations.created_by.name"
                            :email="conversations.created_by.email"
                            size="xs"
                        />
                        <span class="">
                            {{ conversations.created_by.name }}
                        </span>
                    </div>
                    <div class="-conversation"
                        :key="ci"
                        v-for="(conversation, ci) in conversations.items"
                        :class="{ '-from-me': conversation.created_by.id == myUserProfileID,
                        '-info': conversation.type == 'INFO'}"
                    >
                        <!-- <div
                            class="-reply-to__wrapper" 
                            v-if="conversation.created_by.id == myUserProfileID && conversation.message && (!conversations.items[ci + 1] || conversations.items[ci + 1].message != conversation.message || conversation.type != 'INFO')"
                        > -->
                            <!-- <q-btn dense round flat icon="reply" color="grey" class="q-mr-md -reply-button" @click="replying = conversation; $refs.replyInput.$refs.myInput.focus()"/> -->
                        <!-- </div> -->
                        <!-- <div
                            class="-message"
                            :class="{ '-has-replying': conversation.replying_to_message && conversation.replying_to_message != '' }"
                            v-if="conversation.message && (!conversations.items[ci+1] || conversations.items[ci+1].message != conversation.message || conversation.type != 'INFO')"
                        > -->
                        <div
                            class="-message"
                            :class="{ '-has-replying': conversation.replying_to_message && conversation.replying_to_message != '' }"
                            v-if="conversation.message && (!conversations.items[ci+1] || conversations.items[ci+1].message != conversation.message)"
                        >
                            <div class="-message-replying-message" v-if="conversation.replying_to_message && conversation.replying_to_message!=''">
                                <div v-html="conversation.replying_to_message"></div>
                            </div>
                            <div>
                                <q-btn dense round flat icon="reply" color="grey" class="q-ml-sm -reply-button"
                                    @click="replying = conversation; $refs.replyInput.$refs.myInput.focus()" />
                                <div
                                    class="-message-content"
                                    v-html="conversation.message"
                                ></div>
                            </div>
                        </div>
                        <!-- <div class="-reply-to__wrapper" -->
                            <!-- v-if="conversation.created_by.id != myUserProfileID && conversation.message && (!conversations.items[ci + 1] || conversations.items[ci + 1].message != conversation.message || conversation.type != 'INFO')" -->
                        <!-- > -->
                            <!-- <q-btn dense round flat icon="reply" color="grey" class="q-ml-sm -reply-button" @click="replying = conversation; $refs.replyInput.$refs.myInput.focus()"/> -->
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="-reply__wrap" v-if="notification">
            <div class="-replying-to" v-if="replying">
                <div class="row items-center -replying-to-label">
                    <div>
                        En train de répondre à <strong>{{ replying.created_by.name }}</strong>
                    </div>
                    <q-btn @click="replying = null; $refs.replyInput.$refs.myInput.focus()" dense round flat icon="close" class="q-ml-auto" size="sm"/>
                </div>
                <div class="-replying-to-text" v-html="replying.message"></div>
            </div>
            <div class="-reply-input">
                <UserAvatar 
                    :name="myUserProfile.name"
                    :email="myUserProfile.email"
                    class="q-mt-sm"
                    v-if="!isSending"
                />
                <q-spinner color="primary" size="26px" class="q-mr-xs" v-else/>

                <Input
                    ref="replyInput"
                    v-model="replyInput"
                    class="-reply-input q-ml-sm"
                    :filled="false"
                    :borderless="true"
                    dense
                    autogrow 
                    :withEmoji="true"
                    placeholder="Répondre"
                    :submitOnEnter="true"
                    @afterIcon-click="sendReply(replyInput, notification.id)"
                    @enter-submit="sendReply(replyInput, notification.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import { NOTIFICATIONDETAILS/*, NOTIFICATIONSCOUNT/*, PROJECTSINBOX*/ } from "@/graphql/notification/queries";
    import { MARKASREAD, REPLYNOTIFICATION/*, SENDMESSAGE*/ } from "@/graphql/notification/mutations"
    import moment from 'moment';
    import { relativeDate, dayOfWeekStr, dayStr, monthStr, date2str } from "@/js/dateUtilities";
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'NotificationV2',
        props: {
            parentNotification: {
                type: Object,
                default: null
            },
        }, 
        data() {
            return {
                appName: process.env.VUE_APP_NAME,
                myUserProfileID: window.myUserProfileID,
                myUserProfile: window.myUserProfile,
                replyInput: '',
                notification: null,
                markAsReadTO: null,
                skipQueriesStart: true,
                refreshTO: null,
                refreshDelay: 5000,
                replying: null,
                isSending: false,
            }
        },
        mounted(){
            // console.log(this.parentNotification);
        },
        beforeDestroy() {
            if(this.markAsReadTO) clearTimeout(this.markAsReadTO);
            if(this.refreshTO) clearTimeout(this.refreshTO);
        },
        watch:{
            parentNotification(){
                if(this.parentNotification == null){
                    this.notification = null;
                    this.skipQueriesStart = true;
                }else{
                    this.skipQueriesStart = false;
                    this.$nextTick(()=>{
                        if (this.$refs.replyInput) this.$refs.replyInput.$refs.myInput.focus();
                        this.replying = null;
                        this.isSending = false;
                        this.replyInput = '';
                        this.markAsRead();
                    });
                }
            } 
        },
        computed:{
            conversationGroups(){
                let conversationGroups = [];
                // let conversations=this.notification.conversations;
                // console.log(this.notification);
                if(this.notification && this.notification.conversations){
                    let lastCreator=null;
                    let lastDateTime=null

                    this.notification.conversations.forEach( (reply) => {
                        // if(reply.message) {
                        // if(reply.message && reply.message!='') {

                            if(!lastCreator || reply.created_by.id!=lastCreator.id){
                                if (
                                    !lastDateTime 
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<30 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'minutes', true))>=5)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<60 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=15)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))<24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=1)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'days', true))>=1)
                                ){
                                    let dateStr=this.getRelativeDate(reply.created_at);
                                    if(Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=48) {
                                        let date=new Date(moment(reply.created_at));
                                        dateStr=dayOfWeekStr(date).full + ' ' + dayStr(date.getDate()) + ' ' + monthStr(date).full.toLowerCase() + ' ' + date.getFullYear();
                                    }

                                    let infos = [];
                                    if (reply.type == 'INFO') infos.push(reply)

                                    conversationGroups.push({
                                        infos: infos,
                                        created_at: dateStr,
                                        // diff: Math.round(moment().diff(moment(reply.created_at), 'hours', true)),
                                        created_by: reply.created_by,
                                        items: [reply]
                                    });
                                    lastDateTime=reply.created_at;
                                } else {

                                    let infos = [];
                                    if (reply.type == 'INFO') infos.push(reply)

                                    conversationGroups.push({
                                        infos: infos,
                                        created_by: reply.created_by,
                                        items: [reply]
                                    });
                                }
                                
                                lastCreator=reply.created_by;
                            }else if (
                                !lastDateTime 
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<30 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'minutes', true))>=5)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'minutes', true))<60 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=15)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))<24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'hours', true))>=1)
                                    || (Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=24 && Math.round(moment(reply.created_at).diff(moment(lastDateTime), 'days', true))>=1)
                            ){
                                lastDateTime=reply.created_at;

                                let dateStr=this.getRelativeDate(reply.created_at);
                                if(Math.round(moment().diff(moment(reply.created_at), 'hours', true))>=48) {
                                    let date=new Date(moment(reply.created_at));
                                    dateStr=dayOfWeekStr(date).full + ' ' + dayStr(date.getDate()) + ' ' + monthStr(date).full.toLowerCase() + ' ' + date.getFullYear();
                                }

                                let infos = [];
                                if (reply.type == 'INFO') infos.push(reply)

                                conversationGroups.push({
                                    infos: infos,
                                    created_at: dateStr,
                                    created_by: reply.created_by,
                                    // diff: Math.round(moment().diff(moment(reply.created_at), 'hours', true)),
                                    items: [reply]
                                });
                            } else {
                                if (reply.type == 'INFO') {
                                    conversationGroups[conversationGroups.length - 1].infos.push(reply)
                                } //else {
                                    conversationGroups[conversationGroups.length - 1].items.push(reply)
                               // }
                            }
                        // }
                    })
                }

                return conversationGroups.reverse()
            },
        },
        methods: {
            date2str(date) {
                return date2str(date);
            },

            getInfosSummary(infos) {

                let summaryObj = {
                    peutetre: 0,
                    refuse: 0,
                    accepte: 0,
                    annule: 0,
                    modified: 0,
                }
                let summary = []

                infos.forEach(info => {
                    let slug = this.getAcceptation(info.info).slug;
                    summaryObj[slug]++;
                })

                if (summaryObj.accepte == 1) summary.push('<span class="-text-green-dark">1 affectation acceptée</span>')
                if (summaryObj.accepte > 1) summary.push('<span class="-text-green-dark">' + summaryObj.accepte + ' affectations acceptées</span>')
                if (summaryObj.refuse == 1) summary.push('<span class="-text-red">1 affectation refusée</span>')
                if (summaryObj.refuse > 1) summary.push('<span class="-text-red">' + summaryObj.refuse + ' affectations refusées</span>')
                if (summaryObj.peutetre == 1) summary.push('<span class="-text-blue">1 affectation peut-être</span>')
                if (summaryObj.peutetre > 1) summary.push('<span class="-text-blue">' + summaryObj.peutetre + ' affectations peut-être</span>')
                if (summaryObj.annule == 1) summary.push('<span class="-text-gray">1 affectation annulée</span>')
                if (summaryObj.annule > 1) summary.push('<span class="-text-gray">' + summaryObj.annule + ' affectations annulées</span>')
                if (summaryObj.modified == 1) summary.push('<span class="-text-gray">1 affectation modifiée</span>')
                if (summaryObj.modified > 1) summary.push('<span class="-text-gray">' + summaryObj.modified + ' affectations modifiées</span>')

                return '<div class="-summary">' + summary.join('<span class="q-mx-sm">/</span> ') + '</div>';
            },

            getAcceptation(str) {
                // console.log((str))
                if (str.indexOf('annulé') !== -1) return {
                    slug: 'annule',
                    text: 'annulé',
                };  
                if (str.indexOf('refusé') !== -1) return {
                    slug: 'refuse',
                    text: 'refusé',
                };  
                if (str.indexOf('accepté') !== -1) return {
                    slug: 'accepte',
                    text: 'accepté',
                };  
                if (str.indexOf('peut-être') !== -1) return {
                    slug: 'peutetre',
                    text: 'peut-être',
                };  
                if (str.indexOf('modifié') !== -1) return {
                    slug: 'modified',
                    text: 'modifié',
                };  
            },

            refreshDetails(){
                if(this.refreshTO) clearTimeout(this.refreshTO);
                this.refreshTO = setTimeout(()=>{
                    if(!this.parentNotification) return;
                    this.$apollo.queries.notificationDetails.refresh();
                    this.refreshDetails();
                }, this.refreshDelay);
            },

            closePanel(){
                this.skipQueriesStart = true;
                this.$emit('close-panel');
            },

            markAsRead(delay=2000){

                clearTimeout(this.markAsReadTO);

                this.markAsReadTO = setTimeout(() => {
                
                    if (!this.parentNotification || this.parentNotification.read || this.notification.read) return;
                    this.$apollo.mutate({
                        mutation: MARKASREAD,
                        variables: {
                            id: this.parentNotification.id
                        },
                    }).then(function(){
                        this.$eventBus.$emit('notifications-count', { projectID: this.parentNotification.projectID } )
                        this.notification.read=true;
                        // this.watcher=Date.now();
                    }.bind(this))

                }, delay);

            },

            getRelativeDate(date){
                return relativeDate(date);
            },
            sendReply(message, notificationID){
                if (!message || message.trim() == '' || this.isSending) return;

                this.isSending = true;

                let replying = {}
                if (this.replying) replying = {
                    replyingToID: parseInt(this.replying.id),
                    replyingToMessage: this.replying.message,
                }

                this.$apollo.mutate({
                    mutation: REPLYNOTIFICATION,
                    variables: {
                        isReply: true,
                        notificationID: notificationID,
                        message: message,
                        ...replying
                    }
                }).then(function(data){
                    if(data?.data?.replyNotification[0]?.conversations) {
                        this.notification=data.data.replyNotification[0];
                    }

                    this.$eventBus.$emit('subscribe-to-conversation', {
                        notificationID: this.notification.id,
                        expires: 180000
                    });
                    this.replying = null;
                    this.replyInput = '';
                }.bind(this)).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message });
                    this.apolloLoading = false;
                }).finally(() => {
                    this.isSending = false;
                })
            },
        },
        apollo: {
            notificationDetails: {
                query: NOTIFICATIONDETAILS,
                fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                debounce: 200,
                skip(){
                    return this.skipQueriesStart
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                variables() {
                    return {
                        id: this.parentNotification.id,
                    }
                },
                update(data) {
                    // console.log(data)
                    this.markAsRead();
                    this.refreshDetails();
                    this.notification = data.notificationDetails;
                    this.$emit('set-selected-details', data.notificationDetails)
                    return data.notificationDetails;
                },
            },
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            },

        }
    }
</script>
